import React from "react";

export const Landscape = (props: any) => (
  <svg viewBox="0 0 2560 1280" {...props} preserveAspectRatio="xMidYMid slice">
    <path
      fill="#6a80ef"
      d="M.78-2.87h2558.44V1100.8H.78z"
      id="prefix__Layer_5"
      data-name="Layer 5"
    />
    <g id="prefix__land_back" data-name="land back">
      <circle
        cx={333.45}
        cy={693.38}
        r={229.6}
        strokeWidth={6}
        strokeMiterlimit={10}
        stroke="#000"
        fill="#f8b03d"
      />
      <circle
        cx={333.45}
        cy={693.38}
        r={292.22}
        strokeWidth={29}
        strokeDasharray="5.96 49.68"
        fill="none"
        strokeMiterlimit={10}
        stroke="#000"
      />
      <path
        d="M.78 1250.46h2558.44V667c-127.95-120.78-383.79-120.78-511.69 0s-383.79 120.78-511.69 0-383.74-120.78-511.69 0-383.74 230.25-511.68 109.46-383.75-120.78-511.69 0"
        fill="#47e2b9"
      />
      <path
        strokeMiterlimit="1"
        fill="none"
        strokeWidth="6"
        stroke="#000"
        d="M512.47 776.46c-127.9-120.78-383.75-120.78-511.69 0M1024.15 667C896.26 787.82 640.41 897.25 512.47 776.46M1535.84 667c-127.84-120.74-383.74-120.74-511.69 0m1023.38 0c-128 120.78-383.79 120.78-511.69 0m1023.38 0c-127.95-120.78-383.79-120.78-511.69 0"
      />
      <path
        fill="#34b4a1"
        strokeMiterlimit="1"
        strokeWidth="6"
        stroke="#000"
        d="M2290.86 1095.25c-285-245-864.89-254.84-1150-9.85s-855 245-1140.11 0v183.73h2290.11z"
      />
      <path
        d="M2181.39 446.1a39.44 39.44 0 00-58-33.87 58.72 58.72 0 00-109.8-6.61 45.87 45.87 0 00-70.78 39.57zm247.81-138.16a50.78 50.78 0 00-74.8-43.51 75.6 75.6 0 00-141.4-8.33 59.07 59.07 0 00-91 51.07z"
        fill="#fff"
        stroke="#1d1d1b"
        strokeWidth={6}
        strokeMiterlimit={10}
      />
    </g>
    <g id="prefix__snake">
      <path
        fill="#fce8de"
        d="M2425 943.87c0 .06.07 20.56 0 20.56h-62.75v-.81c24-24.93 24-74.77 0-99.67s-24-74.77 0-99.7 24-74.74 0-99.67-24-74.77 0-99.68 20.93-74.77-3.07-99.7l.06-.16a123 123 0 0165.76 108.7z"
      />
      <path
        fill="#f17a5d"
        d="M2362.25 664.58c24 24.93 24 74.77 0 99.67s-24 74.77 0 99.7 24 74.74 0 99.67v.81h-60.4c.06 0 0 .34 0-20.56V573.74a123.18 123.18 0 00-58.32-104.48 118.48 118.48 0 0159.65-17.4 115.73 115.73 0 0156.06 13.14l-.06.16c24 24.93 27.07 74.77 3.07 99.7s-23.97 74.81 0 99.72z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="6"
        stroke="#000"
        d="M2243.53 469.26a118.48 118.48 0 0159.65-17.4 115.73 115.73 0 0156.06 13.14A123 123 0 012425 573.74v370.13c0 .06.07 20.56 0 20.56h-123.15"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth="6"
        stroke="#000"
        d="M2243.53 469.26a123.18 123.18 0 0158.32 104.48v370.13c0 20.9.06 20.56 0 20.56m60.4-.81c24-24.93 24-74.77 0-99.67s-24-74.77 0-99.7 24-74.74 0-99.67-24-74.77 0-99.68 20.93-74.77-3.07-99.7"
      />
      <path
        fill="#f17a5d"
        d="M1169.9 560.4v370.16a.08.08 0 01-.09.09h-61.18c22.76-24.06 22.67-71.66-.31-95.48s-23.06-71.89 0-95.83 23.07-71.85 0-95.83-23.06-71.85 0-95.82c22.76-23.63 20.16-70.59-2.1-94.87a123.14 123.14 0 0163.68 107.58z"
      />
      <path
        fill="#fce8de"
        d="M1108.32 643.51c23.07 24 23.07 71.89 0 95.83s-23.06 71.86 0 95.83 23.07 71.42.31 95.48h-61.79a.08.08 0 01-.09-.09V558.05c0-.07-.06-.1-.13-.1h-115.4c-.06 0-.09-.06-.09-.12a119.39 119.39 0 01116.95-119.27 116.32 116.32 0 0158.14 14.26c22.26 24.28 24.86 71.24 2.1 94.87-23.06 23.97-23.06 71.88 0 95.82zm-82.66-150.68a9.91 9.91 0 10-9.89 9.89 9.9 9.9 0 009.89-9.89z"
      />
      <path
        fill="#1d1d1b"
        d="M1015.77 482.93a9.9 9.9 0 11-9.92 9.9 9.9 9.9 0 019.92-9.9z"
      />
      <path
        d="M1108.63 930.65h-61.79a.08.08 0 01-.09-.09V558.05c0-.07-.06-.1-.13-.1h-115.4c-.06 0-.09-.06-.09-.12a119.39 119.39 0 01116.95-119.27 116.32 116.32 0 0158.14 14.26 123.14 123.14 0 0163.68 107.58v370.16a.08.08 0 01-.09.09z"
        stroke="#1d1d1b"
        strokeMiterlimit={1}
        fill="none"
        strokeWidth={6}
      />
      <path
        d="M1108.32 931c.1-.13.22-.22.31-.35 22.76-24.06 22.67-71.66-.31-95.48s-23.06-71.89 0-95.83 23.07-71.85 0-95.83-23.06-71.85 0-95.82c22.76-23.63 20.16-70.59-2.1-94.87a12.59 12.59 0 00-.87-1"
        stroke="#1d1d1b"
        fill="none"
        strokeWidth={6}
        strokeMiterlimit={10}
      />
      <path
        fill="#e94135"
        stroke="#1d1d1b"
        strokeWidth={6}
        strokeMiterlimit={10}
        d="M996.57 558.82v39.68l-18.21 18.21v-57.89h37.47v39.68l-18.21 18.21v-57.89"
      />
    </g>
    <g id="prefix__Layer_1" data-name="Layer 1">
      <path
        fill="#34b4a1"
        strokeMiterlimit="1"
        strokeWidth="6"
        stroke="#000"
        d="M2523.44 1021.26c-307.24-282-932.46-293.39-1239.81-11.35s-921.83 282-1229.18 0v211.53h2469z"
      />
      <path
        fill="#ead6ce"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1346.46 920.26h670.92v202.77h-670.92z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M779.9 920.26h566.56v146.11H779.9z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M779.9 1063.39h566.56v214.7H779.9zm597.57 26.84h104.96v187.86h-104.96z"
      />
      <path
        fill="#ead6ce"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1482.43 1090.23h78.72v187.86h-78.72zm-183.68 0h78.72v187.86h-78.72z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1878.43 1090.23h104.96v187.86h-104.96z"
      />
      <path
        fill="#ead6ce"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1983.39 1090.23h78.72v187.86h-78.72zm-183.69 0h78.72v187.86h-78.72z"
      />
      <path
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1627.95 1182.67h104.96v95.42h-104.96z"
      />
      <path
        fill="#ead6ce"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1732.91 1182.67h78.72v95.42h-78.72zm-183.68 0h78.72v95.42h-78.72z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1620.79 368.62h113.31v89.46h-113.31z"
      />
      <path
        fill="#f17a5d"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1347.35 779.88c0-184.2 149.32-333.53 333.52-333.53s333.53 149.33 333.53 333.53"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1440.55 778.88c0-183.76 107-332.72 239-332.72s239 149 239 332.72"
      />
      <path
        fill="#f17a5d"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1465.73 778.88c0-183.76 95.73-332.72 213.81-332.72s213.81 149 213.81 332.72"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1587 778.88c0-183.1 40.59-331.53 90.67-331.53s90.68 148.43 90.68 331.53"
      />
      <path
        fill="#f17a5d"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1611.85 778.88c0-183.1 29.47-331.53 65.83-331.53s65.84 148.43 65.84 331.53"
      />
      <rect
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        x={1599.92}
        y={437.2}
        width={155.06}
        height={17.89}
        rx={7.5}
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1677.48 301.53l-38.73 67.09h77.46l-38.73-67.09z"
      />
      <path
        fill="#f17a5d"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M724.78 667.52l-52.93 91.67h105.86l-52.93-91.67z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1316.64 780.12h718.63v29.82h-718.63z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1346.46 809.93h670.92v110.33h-670.92z"
      />
      <circle
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        cx={1677.45}
        cy={860.63}
        r={35.78}
      />
      <circle
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        cx={1239.11}
        cy={991.83}
        r={20.87}
      />
      <circle
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        cx={1064.67}
        cy={991.83}
        r={20.87}
      />
      <circle
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        cx={890.23}
        cy={991.83}
        r={20.87}
      />
      <circle
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        cx={1832.51}
        cy={860.63}
        r={35.78}
      />
      <circle
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        cx={1525.37}
        cy={860.63}
        r={35.78}
      />
      <path
        fill="#f17a5d"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1346.46 1039.54a83.49 83.49 0 01167 0m-116.31 0c0-46.11 14.69-83.49 32.8-83.49s32.8 37.38 32.8 83.49m387.65-2.98a83.49 83.49 0 11167 0"
      />
      <path
        fill="#f17a5d"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1901.09 1036.56c0-46.11 14.68-83.5 32.8-83.5s32.8 37.39 32.8 83.5m-405.54 2.98a119.28 119.28 0 11238.55 0"
      />
      <path
        fill="#f17a5d"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1633.57 1039.54c0-65.87 21-119.28 46.86-119.28s46.86 53.41 46.86 119.28"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1632.72 1036.56h95.42v122.26h-95.42z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1537.3 1158.81h286.26v23.86H1537.3z"
      />
      <path
        fill="#ead6ce"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1728.14 1036.56h71.57v122.26h-71.57zm-166.99 0h71.57v122.26h-71.57z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1396.55 1036.56h66.79v53.67h-66.79z"
      />
      <path
        fill="#ead6ce"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1463.35 1036.56h50.1v53.67h-50.1zm-116.89 0h50.1v53.67h-50.1z"
      />
      <path
        fill="#fde8df"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1900.49 1036.56h66.79v53.67h-66.79z"
      />
      <path
        fill="#ead6ce"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M1967.29 1036.56h50.1v53.67h-50.1zm-116.89 0h50.1v53.67h-50.1z"
      />
      <path
        fill="#f17a5d"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M776.92 920.26h569.54V848.7H848.49l-71.57 71.56z"
      />
      <path
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M888.59 1111.1h6.26a16.25 16.25 0 0116.25 16.25v97.06h-38.76v-97.06a16.25 16.25 0 0116.25-16.25zm169.97 0h6.26a16.25 16.25 0 0116.25 16.25v97.06h-38.76v-97.06a16.25 16.25 0 0116.25-16.25zm175.93 0h6.26a16.25 16.25 0 0116.25 16.25v97.06h-38.76v-97.06a16.25 16.25 0 0116.25-16.25z"
      />
      <path
        fill="#ead6ce"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M779.9 762.23v515.86H669.57V762.23"
      />
      <path
        fill="#9473b0"
        strokeWidth="6"
        strokeMiterlimit="10"
        stroke="#000"
        d="M740.46 1146.89h4.34a11.25 11.25 0 0111.2 11.25v63.3h-26.79v-63.3a11.25 11.25 0 0111.25-11.25zm-35.78 0H709a11.25 11.25 0 0111.25 11.25v63.3h-26.82v-63.3a11.25 11.25 0 0111.25-11.25zm35.78-155.06h4.34a11.25 11.25 0 0111.2 11.25v63.3h-26.79v-63.3a11.25 11.25 0 0111.25-11.25zm-35.78 0H709a11.25 11.25 0 0111.25 11.25v63.3h-26.82v-63.3a11.25 11.25 0 0111.25-11.25zm35.78-155.06h4.34A11.25 11.25 0 01756 848v63.3h-26.79V848a11.25 11.25 0 0111.25-11.23zm-35.78 0H709A11.25 11.25 0 01720.27 848v63.3h-26.84V848a11.25 11.25 0 0111.25-11.23z"
      />
      <path
        d="M212.48 1158.47c254.18-173.72 771.42-180.71 1025.7-7s762.62 173.73 1016.9 0v130.3H212.48z"
        fill="#33bc8b"
      />
      <path
        strokeMiterlimit="1"
        fill="none"
        strokeWidth="6"
        stroke="#000"
        d="M1238.18 1151.48c254.17 173.73 762.62 173.73 1016.9 0"
      />
    </g>
    <g id="prefix__land_front" data-name="land front">
      <path
        fill="#3c9"
        d="M2559.22 958.27c-105.06 28.32-200.63 73.48-274.86 137.27-141.29 121.46-352.65 182.7-564.61 183.72-111 .54 363.38.53 839.47.39"
      />
      <path
        strokeMiterlimit="1"
        fill="none"
        strokeWidth="6"
        stroke="#000"
        d="M212.48 1158.47c254.18-173.72 771.42-180.71 1025.7-7m1046.18-55.93c-141.29 121.46-352.65 182.7-564.61 183.72m839.47-320.99c-105.06 28.32-200.63 73.48-274.86 137.27"
      />
      <path
        fill="#fce8de"
        d="M2441.08 1150.68l-1.69-1.62-13.15-13.16-14.78 14.78h-4.61l-1.68-1.62-13.16-13.16-14.77 14.78h-4.61l-1.69-1.62-13.16-13.16-14.77 14.78h-4.61l-1.68-1.62-18.17-18.17 7.9-7.9 14.22 14.22 17.11-17.11 17.12 17.11 17.11-17.11 17.11 17.11 17.12-17.11 17.11 17.11 7.89-7.89 15.71.09-21.26 21.27h-4.61z"
      />
      <path
        fill="#1d1d1b"
        d="M2392 1122.22l17.11 17.12 17.12-17.12 17.11 17.12 8.51-8.52 11.49.07-18.28 18.29h-3.39l-1.25-1.2-14.19-14.2-15.4 15.4h-3.39l-1.24-1.2-14.2-14.2-15.39 15.4h-3.39L2372 1148l-14.19-14.2-15.4 15.4H2339l-1.24-1.2-17.09-17.09 5.78-5.78 14.22 14.23 17.12-17.12 17.11 17.12 17.11-17.12m0-4.24l-2.12 2.12-15 15-15-15-2.12-2.12-2.13 2.12-15 15-12.1-12.1-2.12-2.12-2.12 2.12-5.78 5.78-2.12 2.12 2.12 2.12 17.09 17.09 1.24 1.2.88.84h5.83l.88-.88 13.28-13.27 12.07 12.07 1.25 1.2.87.84h5.84l.88-.88L2392 1138l12.08 12.07 1.24 1.2.88.84h5.83l.88-.88 13.28-13.27 12.07 12.07 1.25 1.2.87.84h5.84l.88-.88 18.28-18.29 5.08-5.07h-7.18l-11.49-.07h-1.26l-.88.88-6.39 6.39-15-15-2.12-2.12-2.13 2.12-15 15-15-15-2.01-2.03z"
      />
      <path
        fill="#fce8de"
        d="M2441.08 1216.71l-1.69-1.62-13.15-13.16-14.78 14.78h-4.61l-1.68-1.62-13.16-13.15-14.77 14.77h-4.61l-1.69-1.62-13.16-13.16-14.77 14.78h-4.61l-1.68-1.62-18.17-18.17 7.9-7.9 14.22 14.22 17.11-17.11 17.12 17.11 17.11-17.11 17.11 17.11 17.12-17.11 17.11 17.11 7.89-7.89 15.71.1-21.26 21.26h-4.61z"
      />
      <path
        fill="#1d1d1b"
        d="M2392 1188.25l17.11 17.12 17.12-17.11 17.11 17.11 8.51-8.51 11.49.06-18.28 18.29h-3.39l-1.25-1.2-14.19-14.2-15.4 15.4h-3.39l-1.24-1.2-14.2-14.19-15.39 15.39h-3.39L2372 1214l-14.19-14.2-15.4 15.4H2339l-1.24-1.2-17.09-17.09 5.78-5.78 14.22 14.23 17.12-17.11 17.11 17.11 17.11-17.12m0-4.24l-2.12 2.12-15 15-15-15-2.12-2.12-2.13 2.12-15 15-12.1-12.1-2.12-2.12-2.12 2.12-5.78 5.78-2.12 2.12 2.12 2.13 17.09 17.08 1.24 1.2.88.84h5.83l.88-.88 13.28-13.27 12.07 12.07 1.25 1.2.87.84h5.84l.88-.88 13.27-13.27 12.08 12.07 1.24 1.2.88.84h5.83l.88-.88 13.28-13.27 12.07 12.07 1.25 1.2.87.84h5.84l.88-.88 18.28-18.28 5.08-5.08h-7.18l-11.49-.06h-1.26l-.88.88-6.39 6.39-15-15-2.12-2.12-2.13 2.12-15 15-15-15-1.91-2.02z"
      />
      <path
        fill="#79cde0"
        d="M2441.08 1184.31l-1.69-1.62-13.15-13.16-14.78 14.78h-4.61l-1.68-1.62-13.16-13.16-14.77 14.78h-4.61l-1.69-1.62-13.16-13.16-14.77 14.78h-4.61l-1.68-1.62-18.17-18.17 7.9-7.9 14.22 14.22 17.11-17.11 17.12 17.11 17.11-17.11 17.11 17.11 17.12-17.11 17.11 17.11 7.89-7.89 15.71.09-21.26 21.27h-4.61z"
      />
      <path
        fill="#1d1d1b"
        d="M2392 1155.85l17.11 17.11 17.12-17.11 17.11 17.11 8.51-8.51 11.49.07-18.28 18.29h-3.39l-1.25-1.2-14.19-14.2-15.4 15.4h-3.39l-1.24-1.2-14.2-14.2-15.39 15.4h-3.39l-1.25-1.2-14.19-14.2-15.4 15.4H2339l-1.24-1.2-17.09-17.09 5.78-5.78 14.22 14.22 17.12-17.11 17.11 17.15 17.11-17.11m0-4.24l-2.12 2.12-15 15-15-15-2.12-2.12-2.13 2.12-15 15-12.1-12.1-2.12-2.12-2.12 2.12-5.78 5.78-2.12 2.12 2.12 2.12 17.09 17.09 1.24 1.2.88.84h5.83l.88-.88 13.28-13.28 12.07 12.08 1.25 1.2.87.84h5.84l.88-.88 13.27-13.28 12.08 12.08 1.24 1.2.88.84h5.83l.88-.88 13.28-13.28 12.07 12.08 1.25 1.2.87.84h5.84l.88-.88 18.28-18.29 5.08-5.08h-7.18l-11.49-.07h-1.26l-.88.89-6.39 6.39-15-15-2.12-2.12-2.13 2.12-15 15-15-15-2.12-2.12z"
      />
      <circle cx={2453.3} cy={1135.7} r={1.47} />
      <circle cx={2453.3} cy={1169.33} r={1.47} />
      <circle cx={2453.3} cy={1201.73} r={1.47} />
      <path
        fill="#3c9"
        d="M-.22 1279.58c545.66.17 1267.35.3 1133.11-.23-212-.82-423.32-50.24-564.61-148.26C428.49 1034.14 213 990.51 1 990.59"
      />
      <path
        strokeMiterlimit="1"
        fill="none"
        strokeWidth="6"
        stroke="#000"
        d="M1055.66 1280.47q-20.15-1.21-40.18-3c-170.53-15.35-332.11-63-447.2-142.79C428.49 1037.72 213 994.09 1 994.17"
      />
    </g>
  </svg>
);
